import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

const LOGO_URL = 'https://muqmgxvdkwmhuplrulcc.supabase.co/storage/v1/object/public/assets/Logo.gif'

export default function Subscribe() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim()) return
    setLoading(true)
    const { error } = await supabase.from('subscribers').insert({ email: email.trim().toLowerCase() })
    setLoading(false)
    if (!error) { setStatus('success'); setEmail('') }
    else if (error.code === '23505') setStatus('duplicate')
    else setStatus('error')
  }

  return (
    <div className="subscribe-screen">
      <div className="subscribe-box">
        <img src={LOGO_URL} alt="Inside Mag" style={{ width: '100%', maxWidth: 260, height: 'auto', display: 'block', marginBottom: '1rem' }} />


        {status === 'success' ? (
          <div className="subscribe-success">
            <p>You're on the list.</p>
            <p className="subscribe-success-sub">Look out for the next edition.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="subscribe-form">
            <input
              className={'subscribe-input' + (status === 'duplicate' ? ' subscribe-input--error' : '')}
              type="email"
              value={email}
              onChange={e => { setEmail(e.target.value); setStatus(null) }}
              placeholder="your@email.com"
              required
              autoFocus
            />
            {status === 'duplicate' && <p className="subscribe-error">That address is already subscribed.</p>}
            {status === 'error' && <p className="subscribe-error">Something went wrong — try again.</p>}
            <button className="subscribe-btn" type="submit" disabled={loading}>
              {loading ? 'Subscribing…' : 'Subscribe'}
            </button>
          </form>
        )}

      </div>
    </div>
  )
}
